export const CEILING_HEIGHT = 'CEILING_HEIGHT';
